import { render, staticRenderFns } from "./ServiceMoney.vue?vue&type=template&id=48423669&"
import script from "./ServiceMoney.vue?vue&type=script&lang=js&"
export * from "./ServiceMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports